import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { ValidateJLCsvFileResponse } from "../../domain/requests/plans/ValidateJLCsvFileResponse";


@Injectable({ providedIn: 'root' })
export class ImportJobsCSVUseCase implements UseCase<ValidateJLCsvFileResponse,boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param: ValidateJLCsvFileResponse): Observable<boolean> {
    return this.planRepository.importJobsCSV(param);
  }

}